<template>
    <small>
        <div class="list-group">
            <div v-if="hasAffected" class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>Denuncia realizada por:</b></div>
                    <div class="col">
                        <b>Nombre:</b> {{ denounce.accuser.name }},
                        <b>Correo:</b> {{ denounce.accuser.mail }},
                        <b>RUT:</b> {{ formmatedAccuserRut }},
                        <b>Representación invocada:</b> {{ denounce.affected.representation }}
                    </div>
                </div>
            </div>

            <div class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>Fecha de la denuncia:</b></div>
                    <div class="col">
                        {{ formattedCreationDate }}
                    </div>
                </div>
            </div>

            <div class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>Contenido de la denuncia:</b></div>
                    <div class="col">
                        {{ denounce.descripcion }}
                    </div>
                </div>
            </div>

            <div class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>Medidas de protección:</b></div>
                    <div :class="protectionClass">
                        {{ protectionMessage }}
                    </div>
                </div>
            </div>

            <div class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>{{ denouncedLabel }}:</b></div>
                    <div class="col">
                        <b-table-lite small :items="denounce.reported" :fields="accusedFields" bordered
                            class="mb-0"></b-table-lite>
                    </div>
                </div>
            </div>

            <div class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>Vinculo organizacional:</b></div>
                    <div class="col">
                        {{ relationship }}
                    </div>
                </div>
            </div>

            <div class="list-group-item">
                <div class="row">
                    <div class="col-3"><b>Estado del proceso:</b></div>
                    <div class="col">
                        {{ approvalMessage }}
                        <span v-if="resolved">
                            - <b>Fundamento de la resolución:</b>
                            {{ approvalReason }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </small>
</template>
<script>
import { formatRut, formatDateTime } from '@/plugins/complianceScripts';
export default {
    name: "KarinDetails",

    props: {
        denounce: Object,
    },

    data() {
        return {
            accusedFields: [
                { key: 'name', label: 'Nombre' },
                { key: 'rut', label: 'RUT', formatter: formatRut },
                { key: 'mail', label: 'Correo' },
                { key: 'position', label: 'Cargo' },
            ],
        }
    },

    computed: {
        hasAffected() {
            return this.denounce.affected
        },

        formattedCreationDate() {
            return formatDateTime(this.denounce.creationDate)
        },

        approvalMessage() {
            let firstPart
            if (this.denounce.approval === null) {
                firstPart = 'Pendiente';
            } else if (this.denounce.approval.approved) {
                firstPart = 'Aprobado';
            } else {
                firstPart = 'Rechazado';
            }

            let secondPart = this.denounce.approval ? ' por ' + this.denounce.approval.approverMail : '';

            return firstPart + secondPart;
        },

        approvalReason() {
            return this.denounce.approval.reason;
        },

        resolved() {
            return this.denounce.approval !== null && this.denounce.approval.approved;
        },

        relationship() {
            let relation = this.denounce.external.link;
            if (this.denounce.external.isExternal) {
                relation += ' (Externo)';
            }

            return relation;
        },

        denouncedLabel() {
            return this.denounce.reported.length > 1 ? 'Denunciados' : 'Denunciado';
        },

        formmatedAccuserRut() {
            return formatRut(this.denounce.accuser.rut);
        },

        protectionMessage() {
            return this.denounce.preventive ? 'Se solicitan medidas de protección para el afectado' : 'No se solicitan medidas de protección para el afectado';
        },

        protectionClass() {
            return this.denounce.preventive ? 'col text-bold text-danger fw-bold' : 'col text-secondary';
        },

    },

}
</script>
